import React from 'react';
import styled from 'styled-components';
import { FormattedDate } from 'react-intl';
import ChevronUpIcon from '@atlaskit/icon/glyph/hipchat/chevron-up';
import ChevronDownIcon from '@atlaskit/icon/glyph/hipchat/chevron-down';
import EmojiFrequentIcon from '@atlaskit/icon/glyph/emoji/frequent';
import { Dimensions } from 'components/visuals';

const Cell = styled.td<{ width: number }>`
  font-size: 14px;
  align-self: center;
  width: ${({ width }) => width}%;
  padding: ${Dimensions.units(1)}px 0;

  && span {
    line-height: unset;
  }
`;

const ChevronCellWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const LicensesCollapsedRow = ({ showContent, rowItem, isTrial }) => {
  const { accountId, licenseId, expireDate, productDescription, accountName } = rowItem;
  return (
    <>
      <Cell width={15} key="licenses-row-sen">
        <ChevronCellWrapper>
          {showContent ? <ChevronUpIcon label="" /> : <ChevronDownIcon label="" />}
          {isTrial && <EmojiFrequentIcon label="" />}
          SEN-{accountId || `L${licenseId}`}
        </ChevronCellWrapper>
      </Cell>
      <Cell width={15} key="licenses-row-product">
        {productDescription}
      </Cell>
      <Cell width={15} key="licenses-row-site-name">
        {accountName}
      </Cell>
      <Cell width={15} key="licenses-row-support-expire">
        <FormattedDate value={new Date(expireDate)} year="numeric" month="short" day="2-digit" />
      </Cell>
      <Cell width={15} key="licenses-row-support">
        SUPPORT LINK here
      </Cell>
    </>
  );
};
